module.exports = __webpack_public_path__ + "img/checkout.c068d427.svg";